import React from "react";
import {
  Phone as PhoneIcon,
  Message as MessageIcon,
  DataUsage as DataUsageIcon,
  NetworkCheck as NetworkCheckIcon,
} from "@mui/icons-material";
import "./israelcard.css";

// Compact summary of the selected bundle: operator, price, and which kinds
// of allowance it carries. Shares the card's colour system.
const IsrealSmallCard = ({
  logo,
  price,
  hasMinutes,
  hasData,
  hasMessages,
  supports5G,
  accent,
  isDarkTheme = false,
}) => {
  return (
    <div
      className={isDarkTheme ? "il-mini il-mini--dark" : "il-mini"}
      style={accent ? { "--il-accent": accent } : undefined}
    >
      {logo && <img src={logo} alt="" />}
      <span className="il-mini__price">{price}</span>
      <div className="il-mini__icons">
        {hasMinutes && <PhoneIcon />}
        {hasData && <DataUsageIcon />}
        {hasMessages && <MessageIcon />}
        {supports5G && <NetworkCheckIcon />}
      </div>
    </div>
  );
};

export default IsrealSmallCard;
